import React from 'react'
import { Grid, Divider } from '@mui/material'

interface IInstructionGridContainerProps {
  children: React.ReactNode
}
/**
 * InstructionGridContainer
 *
 * @param __namedParameters IInstructionGridContainerProps
 * @returns JSX.Element
 * @category ReactComponents
 */
export const InstructionGridContainer: React.FC<IInstructionGridContainerProps> = ({
  children,
}) => (
  <>
    <Grid
      container
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      paddingX={4}
      height={'56px'}
    >
      {children}
    </Grid>
    <Divider />
  </>
)
